(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  class AnnouncementBar extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.announcement-bar__track');
      this.slides = Array.from(this.querySelectorAll('.announcement-bar__slide'));
      this.toggleButton = this.querySelector('[data-action="toggle"]');
      this.index = 0;
      if (this.slides.length < 2) return;

      this.querySelector('[data-action="previous"]').addEventListener('click', () => this.go(this.index - 1));
      this.querySelector('[data-action="next"]').addEventListener('click', () => this.go(this.index + 1));
      this.toggleButton.addEventListener('click', () => this.setUserPaused(!this.userPaused));

      this.addEventListener('mouseenter', () => this.hold(true));
      this.addEventListener('mouseleave', () => this.hold(false));
      this.addEventListener('focusin', () => this.hold(true));
      this.addEventListener('focusout', (event) => {
        if (!this.contains(event.relatedTarget)) this.hold(false);
      });
      document.addEventListener('visibilitychange', () => this.hold(document.hidden));

      this.addEventListener('shopify:block:select', (event) => {
        this.go(this.slides.indexOf(event.target));
        this.hold(true);
      });
      this.addEventListener('shopify:block:deselect', () => this.hold(false));

      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.setUserPaused(reducedMotion);
    }

    disconnectedCallback() {
      clearInterval(this.timer);
    }

    go(index) {
      const count = this.slides.length;
      this.index = (index + count) % count;
      this.track.style.transform = `translateX(-${this.index * 100}%)`;
      this.slides.forEach((slide, i) => {
        const hidden = i !== this.index;
        slide.toggleAttribute('inert', hidden);
        slide.setAttribute('aria-hidden', hidden);
      });
    }

    setUserPaused(paused) {
      this.userPaused = paused;
      this.toggleAttribute('data-paused', paused);
      const label = paused ? this.toggleButton.dataset.labelPlay : this.toggleButton.dataset.labelPause;
      this.toggleButton.setAttribute('aria-label', label);
      this.update();
    }

    hold(held) {
      this.held = held;
      this.update();
    }

    update() {
      clearInterval(this.timer);
      if (this.userPaused || this.held) return;
      this.timer = setInterval(() => this.go(this.index + 1), 5000);
    }
  }

  if (!customElements.get('announcement-bar')) customElements.define('announcement-bar', AnnouncementBar);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["article"]) return;
  try {
    
  class ArticleEmbeds extends HTMLElement {
    connectedCallback() {
      const embeds = [...this.querySelectorAll('.prd_insert')];
      if (!embeds.length) return;

      this.observer =
        'IntersectionObserver' in window
          ? new IntersectionObserver(this.onIntersect, { rootMargin: '400px 0px' })
          : null;

      embeds.forEach((embed) => {
        embed.setAttribute('data-loading', '');
        if (this.observer) this.observer.observe(embed);
        else this.load(embed);
      });
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }

    onIntersect = (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;

        this.observer.unobserve(entry.target);
        this.load(entry.target);
      });
    };

    /* data-type が Collection なら /collections/<ハンドル>/<タグ>、Search なら /search?q=<語> の読み込み用セクションを取得する */
    embedUrl(embed) {
      const type = (embed.dataset.type || '').toLowerCase();
      const query = (embed.dataset.query || '').trim();
      if (!query) return null;

      if (type === 'search') {
        return `/search?q=${encodeURIComponent(query)}&type=product&options[prefix]=last&section_id=article-products`;
      }

      if (type === 'collection') {
        const tags = (embed.dataset.tags || '')
          .split(',')
          .map((tag) => tag.trim())
          .filter(Boolean)
          .map(encodeURIComponent)
          .join('+');
        return `/collections/${encodeURIComponent(query)}${tags ? `/${tags}` : ''}?section_id=article-products`;
      }

      return null;
    }

    async load(embed) {
      const url = this.embedUrl(embed);

      try {
        if (!url) return;

        const response = await fetch(url, { credentials: 'same-origin' });
        if (!response.ok) return;

        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const content = doc.querySelector('.article-products');
        if (content) embed.replaceChildren(content);
      } catch (error) {
        /* 読み込めなかったときは何も出さない */
      } finally {
        embed.removeAttribute('data-loading');
      }
    }
  }

  if (!customElements.get('article-embeds')) customElements.define('article-embeds', ArticleEmbeds);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  /* カートの行（数量の −／＋・入力・削除）。cart/change.js に送り、応答のセクション HTML を cart:updated で知らせる。
     カートページ（sections/cart.liquid）とドロワーで共通 */
  class CartItems extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', (event) => this.onClick(event));
      this.addEventListener('change', (event) => this.onChange(event));
      this.addEventListener('focusin', (event) => {
        if (event.target.matches('[data-cart-quantity]')) event.target.select();
      });
    }

    onClick(event) {
      const button = event.target.closest('[data-cart-step], [data-cart-remove]');
      if (!button || button.disabled) return;
      const line = button.closest('[data-cart-line]');
      const input = line.querySelector('[data-cart-quantity]');
      const quantity = button.hasAttribute('data-cart-remove')
        ? 0
        : Math.max(0, Number(input.defaultValue) + Number(button.dataset.cartStep));
      this.change(line, quantity);
    }

    onChange(event) {
      const input = event.target.closest('[data-cart-quantity]');
      if (!input) return;
      const quantity = Number.parseInt(input.value, 10);
      if (Number.isNaN(quantity) || quantity < 0 || quantity === Number(input.defaultValue)) {
        input.value = input.defaultValue;
        return;
      }
      this.change(input.closest('[data-cart-line]'), quantity);
    }

    /* 通信中の変更は request に持つ（「購入する」が終わりを待つため。下の CartView の onSubmit） */
    change(line, quantity) {
      if (this.request) return;
      this.request = this.send(line, quantity).finally(() => {
        this.request = null;
      });
    }

    async send(line, quantity) {
      this.setAttribute('aria-busy', 'true');
      line.setAttribute('aria-busy', 'true');
      const detail = { key: line.dataset.cartLine };
      /* Shopify の標準イベント shopify:cart:lines-update で、行の変更を知らせる（snippets/standard-events.liquid） */
      const standardEvent = window.jfCartEvent?.(this, {
        action: quantity > 0 ? 'update' : 'remove',
        context: this.closest('dialog') ? 'dialog' : 'cart',
        lines: [{ id: detail.key, quantity }],
      });
      try {
        const response = await fetch(this.dataset.changeUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            id: detail.key,
            quantity,
            sections: this.dataset.sections,
            sections_url: window.location.pathname,
          }),
        });
        const data = await response.json();
        if (response.ok && !data.errors) {
          Object.assign(detail, { cart: data, sections: data.sections });
          standardEvent?.done(data);
        } else {
          detail.error = data.description || data.errors || this.dataset.errorMessage;
          standardEvent?.done(null, [{ message: String(detail.error), code: 'INVALID' }]);
        }
      } catch (error) {
        detail.error = this.dataset.errorMessage;
        standardEvent?.fail(error);
      }
      /* 失敗しても、カートの実際の状態に合わせて表示を取り直す（上限まで増えた場合など） */
      if (!detail.sections) detail.sections = await this.fetchSections();
      if (detail.sections) {
        this.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail }));
      } else {
        this.removeAttribute('aria-busy');
        line.removeAttribute('aria-busy');
        const message = line.querySelector('[data-cart-line-error]');
        message.textContent = detail.error;
        message.hidden = false;
      }
      return detail;
    }

    async fetchSections() {
      try {
        const url = `${window.location.pathname}?sections=${encodeURIComponent(this.dataset.sections)}`;
        const response = await fetch(url);
        return response.ok ? await response.json() : null;
      } catch (error) {
        return null;
      }
    }
  }

  /* カートの表示（カートページとドロワーで共通）。cart:updated の応答で、自分のセクションの HTML を差し替える。
     商品が入っている状態のまま同じ構成のときは data-cart-block ごとに置き換え、送料無料バーだけは要素を残して
     値を変える（幅の transition を保つため）。ほかは中身をすべて差し替える */
  class CartView extends HTMLElement {
    connectedCallback() {
      this.content = this.querySelector('[data-cart-content]');
      this.status = this.querySelector('[data-cart-status]');
      this.onUpdated = (event) => this.update(event.detail);
      document.addEventListener('cart:updated', this.onUpdated);
      this.addEventListener('submit', (event) => this.onSubmit(event));
    }

    disconnectedCallback() {
      document.removeEventListener('cart:updated', this.onUpdated);
    }

    /* 数量の変更の通信中に「購入する」を押したら、変更が終わってから進む（すぐ進むと、変更が届く前のカートで
       チェックアウトが作られ、変更も消えることがある）。数量の欄に入れて、欄から離れずに押したときは、先にその変更を送る。
       変更に失敗したときは進まない（行の下にエラーが出る） */
    onSubmit(event) {
      const items = this.querySelector('cart-items');
      if (!items) return;
      const edited = Array.from(items.querySelectorAll('[data-cart-quantity]')).find(
        (input) => input.value !== input.defaultValue,
      );
      if (edited) edited.dispatchEvent(new Event('change', { bubbles: true }));
      if (!items.request) return;
      event.preventDefault();
      if (this.waiting) return;
      this.waiting = true;
      items.request
        .catch(() => ({ error: true }))
        .then((detail) => {
          this.waiting = false;
          if (!detail?.error) this.querySelector('button[name="checkout"]')?.click();
        });
    }

    update({ sections, key, error }) {
      const html = sections?.[this.dataset.sectionId];
      const next = html && new DOMParser().parseFromString(html, 'text/html').querySelector('[data-cart-content]');
      if (!next) {
        window.location.reload();
        return;
      }

      const focused = document.activeElement?.closest?.('[data-cart-focus]');
      const focusId = focused && this.contains(focused) ? focused.dataset.cartFocus : null;

      if (this.canMorph(next)) {
        this.morph(next);
      } else {
        this.content.replaceChildren(...next.childNodes);
        this.content.dataset.state = next.dataset.state;
      }

      if (focusId) {
        const target = Array.from(this.querySelectorAll('[data-cart-focus]')).find(
          (element) => element.dataset.cartFocus === focusId && !element.disabled,
        );
        (target || this.querySelector('[data-cart-focus="title"]'))?.focus();
      }

      if (error && key) {
        const line = Array.from(this.querySelectorAll('[data-cart-line]')).find(
          (element) => element.dataset.cartLine === key,
        );
        const message = line?.querySelector('[data-cart-line-error]');
        if (message) {
          message.textContent = error;
          message.hidden = false;
        }
      }

      this.status.textContent = this.querySelector('[data-cart-status-text]')?.textContent || '';
    }

    blocks(root) {
      return Array.from(root.querySelectorAll('[data-cart-block]'), (block) => block.dataset.cartBlock).join();
    }

    canMorph(next) {
      return (
        next.dataset.state === 'items' &&
        this.content.dataset.state === 'items' &&
        this.blocks(next) === this.blocks(this.content)
      );
    }

    morph(next) {
      next.querySelectorAll('[data-cart-block]').forEach((block) => {
        const current = this.content.querySelector(`[data-cart-block="${block.dataset.cartBlock}"]`);
        /* data-cart-keep が同じ値のブロック（おすすめ：元の商品が同じ）は、読み込み直さないよう差し替えない */
        if (block.dataset.cartKeep !== undefined && block.dataset.cartKeep === current.dataset.cartKeep) return;
        if (block.dataset.cartBlock === 'bar') this.morphBar(current, block);
        else current.replaceWith(block);
      });
    }

    morphBar(current, next) {
      const bar = current.querySelector('[data-cart-bar]');
      const nextBar = next.querySelector('[data-cart-bar]');
      bar.dataset.state = nextBar.dataset.state;
      bar.style.setProperty('--cart-bar-progress', nextBar.style.getPropertyValue('--cart-bar-progress'));
      bar.querySelector('[data-cart-bar-message]').replaceWith(nextBar.querySelector('[data-cart-bar-message]'));
    }
  }

  /* カートドロワー。open() は Shopify の標準アクション openCart が探す名前。
     cart:updated に open: true が付いていたら（商品ページの「カートに追加」の成功後）開く */
  class CartDrawer extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      this.addEventListener('click', (event) => {
        if (event.target === this.dialog || event.target.closest('[data-cart-drawer-close]')) this.close();
      });
      this.onUpdated = (event) => {
        if (event.detail?.open) this.open();
      };
      this.onPageShow = (event) => {
        if (event.persisted) this.close();
      };
      document.addEventListener('cart:updated', this.onUpdated);
      window.addEventListener('pageshow', this.onPageShow);

      /* 商品の部分（.cart-drawer__body）が縦にスクロールできると分かるようにする。
         表示・商品の入れ替え・画像の読み込み・画面の大きさの変更・スクロールのたびに合わせ直す */
      this.sync = () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.syncScrollHint());
      };
      this.dialog.addEventListener('scroll', this.sync, true);
      this.dialog.addEventListener('load', this.sync, true);
      this.resizeObserver = new ResizeObserver(this.sync);
      this.resizeObserver.observe(this.dialog);
      this.mutationObserver = new MutationObserver(this.sync);
      this.mutationObserver.observe(this.dialog, { childList: true, subtree: true });
      this.mutationObserver.observe(this.dialog, { attributes: true, attributeFilter: ['open'] });
    }

    disconnectedCallback() {
      document.removeEventListener('cart:updated', this.onUpdated);
      window.removeEventListener('pageshow', this.onPageShow);
      cancelAnimationFrame(this.frame);
      this.resizeObserver?.disconnect();
      this.mutationObserver?.disconnect();
    }

    /* 下に続きがあれば data-more を付ける（下端のフェード） */
    syncScrollHint() {
      const body = this.dialog.open ? this.dialog.querySelector('.cart-drawer__body') : null;
      if (!body) return;
      body.toggleAttribute('data-more', body.scrollHeight - body.scrollTop - body.clientHeight > 4);
    }

    open() {
      if (!this.dialog.open) this.dialog.showModal();
    }

    close() {
      if (this.dialog.open) this.dialog.close();
    }
  }

  /* 「一緒にいかがですか？」（snippets/cart-recommendations.liquid）。Shopify のおすすめを読み込み、カードを並べる。
     閉じているドロワーの中では、開くまで読み込まない。0件・失敗のときは出さないまま */
  class CartRecommendations extends HTMLElement {
    connectedCallback() {
      const dialog = this.closest('dialog');
      if (dialog && !dialog.open) {
        this.observer = new MutationObserver(() => {
          if (!dialog.open) return;
          this.observer.disconnect();
          this.load();
        });
        this.observer.observe(dialog, { attributes: true, attributeFilter: ['open'] });
      } else {
        this.load();
      }
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }

    async load() {
      try {
        const response = await fetch(this.dataset.url);
        if (!response.ok) throw new Error(response.status);
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const items = Array.from(html.querySelectorAll('[data-recs-item]')).slice(0, Number(this.dataset.limit));
        if (!items.length) return;
        this.querySelector('[data-recs-list]').replaceChildren(
          ...items.map((item) => {
            const listItem = document.createElement('li');
            listItem.className = this.dataset.itemClass;
            listItem.append(...item.childNodes);
            return listItem;
          }),
        );
        this.hidden = false;
      } catch (error) {
        this.hidden = true;
      }
    }
  }

  if (!customElements.get('cart-items')) customElements.define('cart-items', CartItems);
  if (!customElements.get('cart-view')) customElements.define('cart-view', CartView);
  if (!customElements.get('cart-drawer')) customElements.define('cart-drawer', CartDrawer);
  if (!customElements.get('cart-recommendations')) customElements.define('cart-recommendations', CartRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  class CollectionDescription extends HTMLElement {
    connectedCallback() {
      this.body = this.querySelector('.collection-description__body');
      this.toggle = this.querySelector('.collection-description__toggle');
      this.toggle.addEventListener('click', () => {
        const expanded = !this.hasAttribute('expanded');
        this.toggleAttribute('expanded', expanded);
        this.toggle.setAttribute('aria-expanded', expanded);
      });
      this.resizeObserver = new ResizeObserver(() => this.updateToggle());
      this.resizeObserver.observe(this.body);
    }

    disconnectedCallback() {
      this.resizeObserver?.disconnect();
    }

    /* 2行に収まる説明文では「続きを読む」を出さない */
    updateToggle() {
      if (this.hasAttribute('expanded')) return;
      this.toggle.hidden = this.body.scrollHeight <= this.body.clientHeight + 1;
    }
  }

  if (!customElements.get('collection-description'))
    customElements.define('collection-description', CollectionDescription);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact"]) return;
  try {
    
  class ContactResult extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      if (!this.dialog || this.dialog.open) return;

      /* 「閉じる」・枠の外（背景）のクリック・Esc で閉じる */
      this.dialog.addEventListener('click', (event) => {
        const box = this.dialog.getBoundingClientRect();
        const outside =
          event.clientX < box.left ||
          event.clientX > box.right ||
          event.clientY < box.top ||
          event.clientY > box.bottom;
        if (outside || event.target.closest('button')) this.dialog.close();
      });
      this.dialog.showModal();

      /* #contact_form への移動でフォーカスが外れることがあるので、読み込みが終わったらボタンに戻す */
      const focusButton = () => {
        if (this.dialog.open && !this.dialog.contains(document.activeElement)) {
          this.dialog.querySelector('button')?.focus({ preventScroll: true });
        }
      };
      if (document.readyState === 'complete') focusButton();
      else window.addEventListener('load', focusButton, { once: true });
    }
  }

  if (!customElements.get('contact-result')) customElements.define('contact-result', ContactResult);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["countdown"] && !Shopify.designMode) return;
  try {
    
  class SaleCountdown extends HTMLElement {
    connectedCallback() {
      this.end = Number(this.dataset.end) * 1000;
      this.fields = {
        days: this.querySelector('[data-days]'),
        hours: this.querySelector('[data-hours]'),
        minutes: this.querySelector('[data-minutes]'),
        seconds: this.querySelector('[data-seconds]'),
      };
      this.tick();
      this.timer = setInterval(() => this.tick(), 1000);
    }

    disconnectedCallback() {
      clearInterval(this.timer);
    }

    tick() {
      const remaining = Math.floor((this.end - Date.now()) / 1000);
      if (remaining <= 0) {
        clearInterval(this.timer);
        this.closest('.shopify-section')?.setAttribute('hidden', '');
        return;
      }
      const pad = (value) => String(value).padStart(2, '0');
      this.fields.days.textContent = Math.floor(remaining / 86400);
      this.fields.hours.textContent = pad(Math.floor((remaining % 86400) / 3600));
      this.fields.minutes.textContent = pad(Math.floor((remaining % 3600) / 60));
      this.fields.seconds.textContent = pad(remaining % 60);
    }
  }

  if (!customElements.get('sale-countdown')) customElements.define('sale-countdown', SaleCountdown);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"]) return;
  try {
    
  class FaqPage extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', this.onClick);
      this.addEventListener('shopify:block:select', this.onBlockSelect);
      this.addEventListener('shopify:block:deselect', this.onBlockDeselect);
      this.observeCategories();
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      this.removeEventListener('shopify:block:select', this.onBlockSelect);
      this.removeEventListener('shopify:block:deselect', this.onBlockDeselect);
      this.observer?.disconnect();
    }

    onClick = (event) => {
      const trigger = event.target.closest('[data-faq-trigger]');
      if (!trigger) return;

      const item = trigger.closest('[data-faq-item]');
      this.setOpen(item, !item.hasAttribute('data-open'));
    };

    /* テーマエディターで質問のブロックを選んだとき、回答が見えるように開く */
    onBlockSelect = (event) => {
      const item = event.target.closest('[data-faq-item]');
      if (item) this.setOpen(item, true);
    };

    onBlockDeselect = (event) => {
      const item = event.target.closest('[data-faq-item]');
      if (item) this.setOpen(item, false);
    };

    setOpen(item, open) {
      item.toggleAttribute('data-open', open);
      item.querySelector('[data-faq-trigger]').setAttribute('aria-expanded', String(open));
    }

    /* 表示中のカテゴリを目次で示す。見出しが固定ヘッダーの下に来る位置（scroll-margin-top）から画面の上40%までを見て、先頭のカテゴリを選ぶ */
    observeCategories() {
      this.observer?.disconnect();

      const categories = [...this.querySelectorAll('[data-faq-category]')];
      if (!categories.length || !('IntersectionObserver' in window)) return;

      const top = parseFloat(getComputedStyle(categories[0]).scrollMarginTop) || 0;
      const visible = new Set();

      this.setCurrent(categories[0].id);

      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) visible.add(entry.target);
            else visible.delete(entry.target);
          });

          /* どのカテゴリも範囲に入っていないとき（ページの先頭や末尾へ一気に移動したときなど）は、見出しが範囲の上端を過ぎた最後のカテゴリ、なければ最初のカテゴリにする */
          const current =
            categories.find((category) => visible.has(category)) ||
            [...categories].reverse().find((category) => category.getBoundingClientRect().top <= top) ||
            categories[0];
          this.setCurrent(current.id);
        },
        { rootMargin: `-${top}px 0px -60% 0px` },
      );

      categories.forEach((category) => this.observer.observe(category));
    }

    setCurrent(id) {
      this.querySelectorAll('[data-faq-link]').forEach((link) => {
        if (link.getAttribute('href') === `#${id}`) link.setAttribute('aria-current', 'true');
        else link.removeAttribute('aria-current');
      });
    }
  }

  if (!customElements.get('faq-page')) customElements.define('faq-page', FaqPage);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class FooterAccordion extends HTMLElement {
    connectedCallback() {
      this.toggle = this.querySelector('.site-footer__toggle');
      this.toggle.addEventListener('click', () => {
        const open = !this.hasAttribute('open');
        this.toggleAttribute('open', open);
        this.toggle.setAttribute('aria-expanded', open);
      });
    }
  }

  if (!customElements.get('footer-accordion')) customElements.define('footer-accordion', FooterAccordion);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gift-card"]) return;
  try {
    
  class GiftCard extends HTMLElement {
    connectedCallback() {
      this.code = this.querySelector('[data-gift-card-code]');
      this.code?.addEventListener('click', () => this.code.select());

      /* 「印刷する」（ボタンは action-button の部品なので、包む要素で受ける） */
      this.querySelector('[data-gift-card-print]')?.addEventListener('click', (event) => {
        if (event.target.closest('button')) window.print();
      });

      this.drawQrCode();
    }

    /* QR コードの部品（Shopify のファイル）は defer で読み込むため、まだなら読み込み完了を待つ */
    drawQrCode() {
      const target = this.querySelector('[data-gift-card-qr]');
      if (!target || target.childElementCount > 0) return;
      const draw = () => {
        if (target.childElementCount === 0) {
          new QRCode(target, { text: target.dataset.identifier, width: 200, height: 200 });
        }
      };
      if (window.QRCode) draw();
      else window.addEventListener('load', draw, { once: true });
    }
  }

  if (!customElements.get('gift-card')) customElements.define('gift-card', GiftCard);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class HeaderMenu extends HTMLElement {
    connectedCallback() {
      this.menu = this.querySelector('#HeaderMenu');
      this.toggleButton = this.querySelector('[data-menu-toggle]');
      this.navButtons = Array.from(this.querySelectorAll('.site-header__nav-item[data-gender]'));
      this.tabs = Array.from(this.querySelectorAll('.header-menu__tab'));
      this.panels = Array.from(this.querySelectorAll('.header-menu__panel'));
      this.desktop = window.matchMedia('(min-width: 990px)');
      this.hover = window.matchMedia('(hover: hover) and (pointer: fine)');
      this.gender = this.dataset.initialGender;

      this.toggleButton.addEventListener('click', () => {
        if (this.isOpen) this.close();
        else this.open(this.gender, this.toggleButton);
      });

      this.navButtons.forEach((button) => {
        button.addEventListener('click', () => {
          clearTimeout(this.hoverTimer);
          /* マウスを乗せて開いたあとのクリックでは閉じず、クリックで開いた状態にする（乗せてから押す人が多いため。
             マウスが離れても閉じなくなり、もう一度押すと閉じる） */
          if (this.isOpen && this.gender === button.dataset.gender && this.openedByHover) this.openedByHover = false;
          else if (this.isOpen && this.gender === button.dataset.gender) this.close();
          else this.open(button.dataset.gender, button);
        });
        button.addEventListener('mouseenter', () => {
          if (!this.hover.matches) return;
          clearTimeout(this.hoverTimer);
          /* クリックで開いているときは、乗せた側の表示に切り替えるだけで、クリックで開いた状態のままにする */
          this.hoverTimer = setTimeout(() => {
            if (this.isOpen && !this.openedByHover) {
              this.trigger = button;
              this.select(button.dataset.gender);
            } else {
              this.open(button.dataset.gender, button, true);
            }
          }, 120);
        });
        button.addEventListener('mouseleave', () => clearTimeout(this.hoverTimer));
      });

      this.addEventListener('mouseleave', () => {
        clearTimeout(this.hoverTimer);
        if (this.openedByHover) this.hoverTimer = setTimeout(() => this.close(false), 200);
      });
      this.addEventListener('mouseenter', () => {
        if (this.openedByHover) clearTimeout(this.hoverTimer);
      });

      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => this.select(tab.dataset.gender));
        tab.addEventListener('keydown', (event) => {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          const next = this.tabs[(this.tabs.indexOf(tab) + 1) % this.tabs.length];
          this.select(next.dataset.gender);
          next.focus();
        });
      });

      this.querySelectorAll('[data-menu-close]').forEach((button) => {
        button.addEventListener('click', () => this.close());
      });

      this.onKeydown = (event) => {
        if (event.key === 'Escape' && this.isOpen) this.close();
      };
      this.onPointerdown = (event) => {
        if (this.isOpen && !this.contains(event.target)) this.close(false);
      };
      this.onFocusout = (event) => {
        if (this.isOpen && this.desktop.matches && event.relatedTarget && !this.contains(event.relatedTarget)) {
          this.close(false);
        }
      };
      this.onBreakpoint = () => this.close(false);

      document.addEventListener('keydown', this.onKeydown);
      document.addEventListener('pointerdown', this.onPointerdown);
      this.addEventListener('focusout', this.onFocusout);
      this.desktop.addEventListener('change', this.onBreakpoint);

      this.select(this.gender);
    }

    disconnectedCallback() {
      document.removeEventListener('keydown', this.onKeydown);
      document.removeEventListener('pointerdown', this.onPointerdown);
      this.desktop.removeEventListener('change', this.onBreakpoint);
      document.documentElement.classList.remove('header-menu-open');
    }

    get isOpen() {
      return !this.menu.hidden;
    }

    select(gender) {
      if (!this.panels.some((panel) => panel.dataset.gender === gender)) return;
      this.gender = gender;
      this.panels.forEach((panel) => (panel.hidden = panel.dataset.gender !== gender));
      this.tabs.forEach((tab) => tab.setAttribute('aria-selected', tab.dataset.gender === gender));
      if (this.isOpen) this.syncButtons();
    }

    open(gender, trigger, byHover = false) {
      this.trigger = trigger;
      this.openedByHover = byHover;
      this.select(gender);
      if (!this.desktop.matches) {
        const top = this.querySelector('.site-header__bar').getBoundingClientRect().bottom;
        this.style.setProperty('--header-menu-top', `${Math.max(top, 0)}px`);
      }
      this.menu.hidden = false;
      document.documentElement.classList.add('header-menu-open');
      this.syncButtons();
    }

    close(restoreFocus = true) {
      if (!this.isOpen) return;
      clearTimeout(this.hoverTimer);
      this.menu.hidden = true;
      this.openedByHover = false;
      document.documentElement.classList.remove('header-menu-open');
      this.syncButtons();
      if (restoreFocus && this.trigger) this.trigger.focus();
    }

    syncButtons() {
      const open = this.isOpen;
      this.toggleButton.setAttribute('aria-expanded', open);
      this.navButtons.forEach((button) => {
        button.setAttribute('aria-expanded', open && button.dataset.gender === this.gender);
      });
    }
  }

  class SearchDialog extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      this.input = this.querySelector('input[name="q"]');
      this.results = this.querySelector('[data-search-results]');
      this.popular = this.querySelector('[data-search-popular]');
      this.status = this.querySelector('[data-search-status]');
      this.desktop = window.matchMedia('(min-width: 990px)');

      this.onOpenClick = (event) => {
        const opener = event.target.closest('[data-search-open]');
        if (!opener) return;
        event.preventDefault();
        this.open(opener);
      };
      document.addEventListener('click', this.onOpenClick);

      this.querySelector('[data-search-close]').addEventListener('click', () => this.dialog.close());
      this.dialog.addEventListener('click', (event) => {
        if (event.target === this.dialog) this.dialog.close();
      });
      this.dialog.addEventListener('close', () => this.opener?.focus());
      this.input.addEventListener('input', () => {
        clearTimeout(this.debounce);
        this.debounce = setTimeout(() => this.suggest(), 300);
      });
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.onOpenClick);
    }

    open(opener) {
      this.opener = opener;
      document.querySelector('header-menu')?.close(false);
      const placeholder = this.desktop.matches ? 'placeholderDesktop' : 'placeholderMobile';
      this.input.placeholder = this.input.dataset[placeholder];
      this.dialog.showModal();
      this.input.focus();
      this.loadPopular();
    }

    async loadPopular() {
      if (this.popularLoaded) return;
      this.popularLoaded = true;
      const content = await this.fetchSection(this.dialog.dataset.popularUrl);
      if (content) this.popular.replaceChildren(...content.childNodes);
      else this.popularLoaded = false;
    }

    async suggest() {
      const terms = this.input.value.trim();
      this.abortController?.abort();

      if (!terms) {
        this.results.hidden = true;
        this.results.replaceChildren();
        this.popular.hidden = false;
        this.status.textContent = '';
        return;
      }

      this.abortController = new AbortController();
      const params = new URLSearchParams({
        q: terms,
        type: 'product',
        'options[prefix]': 'last',
        'options[unavailable_products]': 'last',
        section_id: 'predictive-search',
      });
      const content = await this.fetchSection(
        `${this.dialog.dataset.suggestUrl}?${params}`,
        this.abortController.signal,
      );
      if (!content) return;

      const panel = content.querySelector('[data-result-count]');
      const count = Number(panel?.dataset.resultCount || 0);
      this.results.replaceChildren(...content.childNodes);
      this.results.hidden = false;
      this.popular.hidden = count > 0;
      this.status.textContent = panel?.dataset.statusText || '';
    }

    async fetchSection(url, signal) {
      try {
        const response = await fetch(url, { signal });
        if (!response.ok) return null;
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        return html.querySelector('.shopify-section');
      } catch (error) {
        return null;
      }
    }
  }

  if (!customElements.get('header-menu')) customElements.define('header-menu', HeaderMenu);
  if (!customElements.get('search-dialog')) customElements.define('search-dialog', SearchDialog);

  /* カートアイコンはドロワー（sections/cart-drawer.liquid）を開く。ドロワーのないカートページでは、そのままカートページへ移る */
  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-cart-link]');
    const drawer = document.querySelector('cart-drawer');
    if (!link || !drawer?.open || event.defaultPrevented) return;
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    drawer.open();
  });

  /* カートが変わったら、読み込み用セクション（sections/cart-count.liquid）の値でカートアイコンの件数を差し替える */
  document.addEventListener('cart:updated', (event) => {
    const html = event.detail?.sections?.['cart-count'];
    const source = html && new DOMParser().parseFromString(html, 'text/html').querySelector('[data-cart-count]');
    if (!source) return;
    document.querySelectorAll('[data-cart-link]').forEach((link) => {
      link.setAttribute('aria-label', source.dataset.label);
      const badge = link.querySelector('[data-cart-badge]');
      if (!badge) return;
      badge.textContent = source.dataset.badge;
      badge.hidden = source.dataset.count === '0';
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  class HeroBanner extends HTMLElement {
    connectedCallback() {
      if (!this.hasAttribute('data-animate') || !('IntersectionObserver' in window)) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      let first = true;
      this.observer = new IntersectionObserver((entries) => {
        const visible = entries.some((entry) => entry.isIntersecting);
        if (first && !visible) this.setAttribute('data-reveal-pending', '');
        first = false;
        if (!visible) return;
        this.removeAttribute('data-reveal-pending');
        this.observer.disconnect();
      });
      this.observer.observe(this);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }
  }

  if (!customElements.get('hero-banner')) customElements.define('hero-banner', HeroBanner);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-slider"] && !Shopify.designMode) return;
  try {
    
  class ImageSlider extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.image-slider__track');
      this.slides = Array.from(this.querySelectorAll('.image-slider__slide'));
      this.dots = Array.from(this.querySelectorAll('.image-slider__dot'));

      this.dots.forEach((dot, index) => {
        dot.addEventListener('click', () => {
          const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.scrollToSlide(index, reduced ? 'auto' : 'smooth');
        });
      });

      this.track.addEventListener('scroll', () => this.update(), { passive: true });
      this.resizeObserver = new ResizeObserver(() => this.update());
      this.resizeObserver.observe(this.track);

      // テーマエディターでスライドを選んだら、そのスライドを表示する
      this.addEventListener('shopify:block:select', (event) => {
        const index = this.slides.indexOf(event.target);
        if (index >= 0) this.scrollToSlide(index, 'auto');
      });
    }

    disconnectedCallback() {
      this.resizeObserver?.disconnect();
    }

    /* 1枚ぶんの送り幅（スライドの幅＋間隔） */
    get step() {
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      return this.slides[0].getBoundingClientRect().width + gap;
    }

    scrollToSlide(index, behavior) {
      const max = this.track.scrollWidth - this.track.clientWidth;
      this.track.scrollTo({ left: Math.min(index * this.step, max), behavior });
    }

    /* 送れる位置の数だけドットを出し、今の位置のドットに印を付ける。末尾まで来たら最後のドット */
    update() {
      if (!this.slides.length || !this.dots.length) return;
      const step = this.step;
      if (!step) return;
      const max = this.track.scrollWidth - this.track.clientWidth;
      const positions = Math.min(this.slides.length, Math.ceil(max / step - 0.01) + 1);
      const current = this.track.scrollLeft >= max - 1 ? positions - 1 : Math.round(this.track.scrollLeft / step);
      this.dots.forEach((dot, i) => {
        dot.hidden = i >= positions || positions < 2;
        if (i === current) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
    }
  }

  if (!customElements.get('image-slider')) customElements.define('image-slider', ImageSlider);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["popular-categories"] && !Shopify.designMode) return;
  try {
    
  class CategoryList extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('.categories__tab'));
      this.panels = Array.from(this.querySelectorAll('.categories__panel'));

      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => this.select(tab.dataset.panel));
        tab.addEventListener('keydown', (event) => {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          const next = this.tabs[(this.tabs.indexOf(tab) + 1) % this.tabs.length];
          this.select(next.dataset.panel);
          next.focus();
        });
      });

      this.panels.forEach((panel) => this.enableDrag(panel.querySelector('.categories__track')));
    }

    select(key) {
      this.panels.forEach((panel) => {
        panel.hidden = panel.dataset.panel !== key;
        if (panel.hidden) return;
        panel.querySelector('.categories__track').scrollLeft = 0;
        panel.querySelector('scroll-arrows')?.update?.();
      });
      this.tabs.forEach((tab) => {
        const selected = tab.dataset.panel === key;
        tab.setAttribute('aria-selected', selected);
        tab.tabIndex = selected ? 0 : -1;
      });
    }

    /* PC はマウスで横にドラッグしても送れる（矢印もある）。少し動いたらリンクのクリックを止める */
    enableDrag(track) {
      let startX = 0;
      let startScroll = 0;
      let moved = false;
      let active = false;

      track.addEventListener('pointerdown', (event) => {
        if (event.pointerType !== 'mouse' || event.button !== 0) return;
        active = true;
        moved = false;
        startX = event.clientX;
        startScroll = track.scrollLeft;
      });
      track.addEventListener('pointermove', (event) => {
        if (!active) return;
        const distance = event.clientX - startX;
        if (!moved && Math.abs(distance) > 5) {
          moved = true;
          track.classList.add('is-dragging');
          track.setPointerCapture(event.pointerId);
        }
        if (moved) track.scrollLeft = startScroll - distance;
      });
      const end = () => {
        active = false;
        track.classList.remove('is-dragging');
      };
      track.addEventListener('pointerup', end);
      track.addEventListener('pointercancel', end);
      track.addEventListener(
        'click',
        (event) => {
          if (!moved) return;
          event.preventDefault();
          moved = false;
        },
        true,
      );
    }
  }

  if (!customElements.get('category-list')) customElements.define('category-list', CategoryList);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('.product-recs__tab'));
      this.panels = Array.from(this.querySelectorAll('.product-recs__panel'));
      this.arrowGroup = this.querySelector('.product-recs__arrows');
      this.arrows = Array.from(this.querySelectorAll('.product-recs__arrow'));
      this.progress = this.querySelector('.product-recs__progress');

      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => this.select(tab.dataset.panel));
        tab.addEventListener('keydown', (event) => {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          const visible = this.tabs.filter((item) => !item.hidden);
          const step = event.key === 'ArrowRight' ? 1 : -1;
          const next = visible[(visible.indexOf(tab) + step + visible.length) % visible.length];
          this.select(next.dataset.panel);
          next.focus();
        });
      });

      this.arrows.forEach((arrow) => {
        arrow.addEventListener('click', () => {
          const track = this.activeTrack;
          const item = track?.querySelector('.product-recs__item');
          if (!item) return;
          const step = item.getBoundingClientRect().width + 18;
          const max = track.scrollWidth - track.clientWidth;
          const left = Math.min(Math.max(track.scrollLeft + step * Number(arrow.dataset.direction), 0), max);
          track.scrollTo({ left, behavior: 'smooth' });
        });
      });

      this.panels.forEach((panel) => {
        panel
          .querySelector('.product-recs__track')
          .addEventListener('scroll', () => this.updateControls(), { passive: true });
      });
      this.resizeObserver = new ResizeObserver(() => this.updateControls());
      this.resizeObserver.observe(this);

      /*
        画面に近づいてから読み込む。読み込むまで欄の高さは 0 で、速くスクロールすると、表示された欄が下の欄（カテゴリー以下）を押し下げる。
        スマホで少しスクロールした時点（画面の下から 1500px 手前）で読み込み始め、届く前に欄を出しておく
      */
      this.visibilityObserver = new IntersectionObserver(
        (entries) => {
          if (!entries.some((entry) => entry.isIntersecting)) return;
          this.visibilityObserver.disconnect();
          this.load();
        },
        { rootMargin: '1500px 0px' },
      );
      this.visibilityObserver.observe(this.parentElement);
    }

    disconnectedCallback() {
      this.resizeObserver?.disconnect();
      this.visibilityObserver?.disconnect();
    }

    get activeTrack() {
      return this.panels.find((panel) => !panel.hidden)?.querySelector('.product-recs__track');
    }

    async load() {
      await Promise.all(this.panels.map((panel) => this.loadPanel(panel)));
      const available = this.panels.filter((panel) => Number(panel.dataset.count) > 0);
      this.tabs.forEach((tab) => {
        tab.hidden = !available.some((panel) => panel.dataset.panel === tab.dataset.panel);
      });
      if (available.length === 0) return;
      this.hidden = false;
      this.select(available[0].dataset.panel);
    }

    /* 表示中の商品を除き、設定の件数まで並べる */
    async loadPanel(panel) {
      try {
        const response = await fetch(panel.dataset.url);
        if (!response.ok) throw new Error(response.status);
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const items = Array.from(html.querySelectorAll('[data-recs-item]'))
          .filter((source) => source.dataset.productId !== this.dataset.productId)
          .slice(0, Number(this.dataset.limit))
          .map((source) => {
            const item = document.createElement('li');
            item.className = 'product-recs__item';
            item.append(...source.childNodes);
            return item;
          });
        panel.querySelector('.product-recs__track').replaceChildren(...items);
        panel.dataset.count = items.length;
      } catch (error) {
        panel.dataset.count = 0;
      }
    }

    select(key) {
      this.panels.forEach((panel) => (panel.hidden = panel.dataset.panel !== key));
      this.tabs.forEach((tab) => {
        const selected = tab.dataset.panel === key;
        tab.setAttribute('aria-selected', selected);
        tab.tabIndex = selected ? 0 : -1;
      });
      const track = this.activeTrack;
      if (track) track.scrollLeft = 0;
      this.updateControls();
    }

    updateControls() {
      const track = this.activeTrack;
      if (!track) return;
      const max = track.scrollWidth - track.clientWidth;
      this.arrowGroup.hidden = max <= 1;
      const [previous, next] = this.arrows;
      previous.disabled = track.scrollLeft <= 1;
      next.disabled = track.scrollLeft >= max - 1;
      this.progress.hidden = max <= 1;
      this.progress.style.setProperty('--size', track.clientWidth / track.scrollWidth);
      this.progress.style.setProperty('--position', track.scrollLeft / track.clientWidth);
    }
  }

  if (!customElements.get('product-recommendations'))
    customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-showcase"] && !Shopify.designMode) return;
  try {
    
  class ProductShowcase extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('.showcase__tab'));
      this.panels = Array.from(this.querySelectorAll('.showcase__panel'));
      this.links = Array.from(this.querySelectorAll('.showcase__view-all'));

      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => this.select(tab.dataset.panel));
        tab.addEventListener('keydown', (event) => {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          const next = this.tabs[(this.tabs.indexOf(tab) + 1) % this.tabs.length];
          this.select(next.dataset.panel);
          next.focus();
        });
      });

      this.visibilityObserver = new IntersectionObserver(
        (entries) => {
          if (!entries.some((entry) => entry.isIntersecting)) return;
          this.visible = true;
          this.visibilityObserver.disconnect();
          this.loadRanking(this.activePanel);
        },
        { rootMargin: '300px 0px' },
      );
      this.visibilityObserver.observe(this);
    }

    disconnectedCallback() {
      this.visibilityObserver?.disconnect();
    }

    get activePanel() {
      return this.panels.find((panel) => !panel.hidden);
    }

    get activeTrack() {
      return this.activePanel?.querySelector('.showcase__track');
    }

    select(key) {
      this.panels.forEach((panel) => (panel.hidden = panel.dataset.panel !== key));
      this.links.forEach((link) => (link.hidden = link.dataset.panel !== key));
      this.tabs.forEach((tab) => {
        const selected = tab.dataset.panel === key;
        tab.setAttribute('aria-selected', selected);
        tab.tabIndex = selected ? 0 : -1;
      });
      const track = this.activeTrack;
      if (track) track.scrollLeft = 0;
      this.activePanel?.querySelector('scroll-arrows')?.update?.();
      if (this.visible) this.loadRanking(this.activePanel);
    }

    async loadRanking(panel) {
      if (!panel?.dataset.rankingUrl || panel.dataset.rankingState) return;
      panel.dataset.rankingState = 'loading';
      const track = panel.querySelector('.showcase__track');
      try {
        const response = await fetch(panel.dataset.rankingUrl);
        if (!response.ok) throw new Error(response.status);
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const items = Array.from(html.querySelectorAll('[data-ranking-item]'))
          .slice(0, Number(this.dataset.limit))
          .map((source) => {
            const item = document.createElement('li');
            item.className = 'showcase__item';
            item.append(...source.childNodes);
            return item;
          });
        track.replaceChildren(...items);
        panel.querySelector('.showcase__empty').hidden = items.length > 0;
        panel.dataset.rankingState = 'done';
      } catch (error) {
        panel.dataset.rankingState = '';
      }
      panel.removeAttribute('aria-busy');
    }
  }

  if (!customElements.get('product-showcase')) customElements.define('product-showcase', ProductShowcase);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  class ProductInfo extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      this.quantity = this.querySelector('input[name="quantity"]');
      try {
        this.variants = JSON.parse(this.querySelector('[data-product-variants]')?.textContent || '[]');
      } catch {
        this.variants = [];
      }

      this.addEventListener('change', (event) => {
        if (event.target.matches('[data-option-value-id]')) this.onOptionChange(event.target);
      });
      this.querySelectorAll('[data-quantity-step]').forEach((button) => {
        button.addEventListener('click', () => this.stepQuantity(Number(button.dataset.quantityStep)));
      });
      this.form?.addEventListener('submit', (event) => this.onSubmit(event));
      this.setupSticky();
    }

    /* 下に固定するバーは、購入ボタンが画面の上へ抜けたあと（購入ボタンより下にいる間）だけ出し、フッターが見えたら隠す。
       売り切れのバリエーションでは「サイズを選ぶ」でオプションの欄へスクロールする */
    setupSticky() {
      const sticky = this.querySelector('[data-product-sticky]');
      if (!sticky) return;
      const buttons = this.querySelector('.product-form__buttons');
      const footer = document.querySelector('.shopify-section-group-footer-group');
      let passed = false;
      let footerVisible = false;
      const update = () => sticky.toggleAttribute('data-visible', passed && !footerVisible);
      /* 購入ボタンは、画面の上端より下を全部見る枠で見張る（枠から外れた＝上へ抜けた）。画面の上下を一気に移っても、必ず上端をまたぐので取りこぼさない */
      if (buttons) {
        new IntersectionObserver(
          ([entry]) => {
            passed = !entry.isIntersecting;
            update();
          },
          { rootMargin: '0px 0px 100000px 0px' },
        ).observe(buttons);
      }
      if (footer) {
        new IntersectionObserver(([entry]) => {
          footerVisible = entry.isIntersecting;
          update();
        }).observe(footer);
      }
      sticky.addEventListener('click', (event) => {
        if (!event.target.closest('[data-product-sticky-choose]')) return;
        if (this.sizeSheet) {
          this.openSizeSheet();
          return;
        }
        const options = this.querySelector('.product-option--size') || this.querySelector('.product-options');
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        options?.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
        options?.querySelector('input:checked')?.focus({ preventScroll: true });
      });

      this.sizeSheet = this.querySelector('[data-product-size-sheet]');
      this.sizeSheet?.addEventListener('click', (event) => {
        const box = this.sizeSheet.getBoundingClientRect();
        const outside =
          event.clientX < box.left ||
          event.clientX > box.right ||
          event.clientY < box.top ||
          event.clientY > box.bottom;
        if (outside || event.target.closest('[data-product-size-sheet-close]')) this.sizeSheet.close();
        /* サイズの選び方は、ページのリンクと同じモーダル（snippets/size-guide-dialog.liquid）を開く */
        if (event.target.closest('[data-product-size-guide]')) {
          this.sizeSheet.close();
          this.querySelector('.product-option__guide')?.click();
        }
      });
    }

    /* サイズの小窓を開く。ボタンは、ページのサイズの欄の今の状態（選択中・売り切れ）から作る */
    openSizeSheet() {
      const soldOut = this.sizeSheet.dataset.soldOutLabel;
      const buttons = Array.from(this.querySelectorAll('.product-option--size [data-option-value-id]'), (input) => {
        const unavailable = this.querySelector(`label[for="${input.id}"]`)?.classList.contains(
          'product-option__value--unavailable',
        );
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'product-size-sheet__value';
        button.textContent = input.value;
        button.disabled = Boolean(unavailable);
        button.setAttribute('aria-pressed', String(input.checked));
        if (unavailable) button.setAttribute('aria-label', `${input.value} ${soldOut}`);
        button.addEventListener('click', () => {
          this.sizeSheet.close();
          if (input.checked) return;
          input.checked = true;
          input.dispatchEvent(new Event('change', { bubbles: true }));
          /* バーの中身は取り直しで変わるが、サイズだけは先に変える */
          const value = this.querySelector('[data-product-sticky-size]');
          if (value) value.textContent = input.value;
        });
        return button;
      });
      this.sizeSheet.querySelector('[data-product-size-sheet-values]').replaceChildren(...buttons);
      this.sizeSheet.showModal();
    }

    stepQuantity(step) {
      const value = Math.max(1, (parseInt(this.quantity.value, 10) || 1) + step);
      this.quantity.value = value;
      this.quantity.dispatchEvent(new Event('change', { bubbles: true }));
    }

    /* 選んだオプションでセクションを取り直し、価格・オプション・在庫・ボタンを差し替える */
    async onOptionChange(input) {
      const legendValue = input.closest('fieldset')?.querySelector('.product-option__legend span');
      if (legendValue) legendValue.textContent = input.value;
      const checked = Array.from(this.querySelectorAll('[data-option-value-id]:checked'));
      const values = checked.map((item) => item.value);
      this.selectVariant(
        this.variants.find((variant) => variant.options.every((value, index) => value === values[index])),
      );
      const optionValues = checked.map((item) => item.dataset.optionValueId).join(',');
      const params = new URLSearchParams({ section_id: this.dataset.sectionId, option_values: optionValues });

      this.abortController?.abort();
      this.abortController = new AbortController();
      try {
        const response = await fetch(`${this.dataset.productUrl}?${params}`, { signal: this.abortController.signal });
        if (!response.ok) throw new Error(response.status);
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const next = html.querySelector(`product-info[data-section-id="${this.dataset.sectionId}"]`);
        if (!next) throw new Error('product-info not found');
        this.update(next);
      } catch (error) {
        if (error.name !== 'AbortError') console.error(error);
      }
    }

    /* 選んだ組み合わせのバリエーションを、取り直しを待たずにフォームの id に入れる。購入ボタンと Shop Pay などのボタンは
       フォームの id を送るため、取り直しの間に押しても、選んだバリエーションで進む（価格・在庫は、取り直しのあとで変わる）。
       購入ボタンの文字・押せるかどうかと Shop Pay なども、ここで一覧の在庫から先に変え、取り直しのあとでサーバーの値に揃える。
       売り切れ・組み合わせがないときは購入に進ませない（組み合わせがないときは id を空にし、売り切れと同じ表示にする） */
    selectVariant(variant) {
      const variantId = variant ? String(variant.id) : '';
      const available = Boolean(variant?.available);
      this.dataset.variantId = variantId;
      this.dataset.available = String(available);
      this.querySelector('[data-product-variant-id]').value = variantId;
      const submit = this.querySelector('[data-product-region="submit"]');
      if (submit) {
        submit.disabled = !available;
        submit.textContent = available ? this.dataset.addToCartLabel : this.dataset.soldOutLabel;
      }
      const payment = this.querySelector('[data-product-payment]');
      if (payment) payment.hidden = !available;
    }

    update(next) {
      const focusedId = document.activeElement?.id;
      this.querySelectorAll('[data-product-region]').forEach((region) => {
        const replacement = next.querySelector(`[data-product-region="${region.dataset.productRegion}"]`);
        if (!replacement) return;
        /* 購入ボタンは、要素を差し替えずに中身だけ更新する（Klaviyo の入荷通知が、売り切れのときにこのボタンを隠すため） */
        if (region.dataset.productRegion === 'submit') {
          region.disabled = replacement.disabled;
          region.textContent = replacement.textContent;
        } else {
          region.replaceWith(replacement);
        }
      });
      if (focusedId) document.getElementById(focusedId)?.focus();
      /* バリエーションの一覧の在庫も、取り直した値にする（次に選んだときの先の表示が、サーバーの値と食い違わないように） */
      try {
        this.variants =
          JSON.parse(next.querySelector('[data-product-variants]')?.textContent || 'null') || this.variants;
      } catch {}

      const { variantId, mediaId, available } = next.dataset;
      Object.assign(this.dataset, { variantId, mediaId, available });
      this.querySelector('[data-product-variant-id]').value = variantId;
      const payment = this.querySelector('[data-product-payment]');
      if (payment) payment.hidden = available !== 'true';
      this.showError('');

      const url = new URL(window.location.href);
      url.searchParams.set('variant', variantId);
      window.history.replaceState(window.history.state, '', url);
      /* バリエーションの変更を、URL と variant id を更新したあとで知らせる（Klaviyo の入荷通知が、change を見て売り切れかどうかを調べる） */
      this.querySelector('[data-product-variant-id]').dispatchEvent(new Event('change', { bubbles: true }));

      if (typeof window._paidy === 'function') window._paidy('pm:refresh');
      this.dispatchEvent(new CustomEvent('product:variant-change', { bubbles: true, detail: { variantId, mediaId } }));
    }

    /* カートに追加：成功したらカートドロワー（sections/cart-drawer.liquid）を開く。ドロワーがなければカートページへ移る。
       応答にドロワーとカート件数のセクションを含め、cart:updated で知らせる。失敗はボタンの下に出す */
    async onSubmit(event) {
      event.preventDefault();
      const submit = this.querySelector('[data-product-region="submit"]');
      if (!submit || submit.disabled || submit.getAttribute('aria-busy') === 'true') return;
      if (this.dataset.available !== 'true') return;
      /* 下に固定するバーから押したときは、そのボタンも待機中にする */
      const busyButtons = [submit, event.submitter].filter(Boolean);
      const setBusy = (busy) =>
        busyButtons.forEach((button) =>
          busy ? button.setAttribute('aria-busy', 'true') : button.removeAttribute('aria-busy'),
        );
      setBusy(true);
      this.showError('');
      /* Shopify の標準イベント shopify:cart:lines-update で、追加を知らせる（snippets/standard-events.liquid） */
      const standardEvent = window.jfCartEvent?.(this, {
        action: 'add',
        context: 'product',
        lines: [{ merchandiseId: this.dataset.variantId, quantity: Number.parseInt(this.quantity.value, 10) || 1 }],
      });
      try {
        const body = new FormData(this.form);
        body.append('sections', 'cart-drawer,cart-count');
        const response = await fetch(this.dataset.cartAddUrl, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body,
        });
        const data = await response.json().catch(() => ({}));
        /* 追加の応答は行の情報だけなので、イベントに渡すカートは、画面の更新を待たせずに取り直す */
        const settle = (userErrors) => {
          if (!standardEvent) return;
          fetch('/cart.js')
            .then((result) => result.json())
            .catch(() => null)
            .then((cart) => standardEvent.done(cart, userErrors));
        };
        if (response.ok) {
          settle();
          if (data.sections?.['cart-drawer'] && document.querySelector('cart-drawer')?.open) {
            document.dispatchEvent(
              new CustomEvent('cart:updated', { detail: { sections: data.sections, open: true } }),
            );
            setBusy(false);
          } else {
            window.location.assign(this.dataset.cartUrl);
          }
          return;
        }
        const message = data.description || data.message || this.dataset.errorMessage;
        settle([{ message: String(message), code: 'INVALID' }]);
        this.showError(message);
      } catch (error) {
        standardEvent?.fail(error);
        this.showError(this.dataset.errorMessage);
      }
      setBusy(false);
    }

    showError(message) {
      const error = this.querySelector('[data-product-error]');
      if (!error) return;
      error.textContent = message || '';
      error.hidden = !message;
    }
  }

  if (!customElements.get('product-info')) customElements.define('product-info', ProductInfo);

  class ProductDescription extends HTMLElement {
    connectedCallback() {
      this.body = this.querySelector('.product-description__body');
      this.toggle = this.querySelector('.product-description__toggle');
      this.toggle.addEventListener('click', () => this.setExpanded(!this.hasAttribute('data-expanded')));
      this.resizeObserver = new ResizeObserver(() => this.update());
      this.resizeObserver.observe(this.body);
      this.update();
    }

    disconnectedCallback() {
      this.resizeObserver?.disconnect();
    }

    /* 5行に収まるときはボタンもフェードも出さない */
    update() {
      if (this.hasAttribute('data-expanded')) return;
      const truncated = this.body.scrollHeight > this.body.clientHeight + 1;
      this.toggle.hidden = !truncated;
      this.toggleAttribute('data-truncated', truncated);
    }

    setExpanded(expanded) {
      this.toggleAttribute('data-expanded', expanded);
      this.toggle.setAttribute('aria-expanded', expanded);
      this.update();
    }
  }

  if (!customElements.get('product-description')) customElements.define('product-description', ProductDescription);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recently-viewed"] && !Shopify.designMode) return;
  try {
    
  class RecentlyViewed extends HTMLElement {
    static storageKey = 'jf-recently-viewed';

    connectedCallback() {
      this.track = this.querySelector('.recently-viewed__track');
      this.arrowGroup = this.querySelector('.recently-viewed__arrows');
      this.arrows = Array.from(this.querySelectorAll('.recently-viewed__arrow'));

      const history = this.readHistory();
      const ids = history.filter((id) => id !== this.dataset.productId).slice(0, Number(this.dataset.limit));
      this.saveHistory([this.dataset.productId, ...history.filter((id) => id !== this.dataset.productId)]);

      this.arrows.forEach((arrow) => {
        arrow.addEventListener('click', () => {
          const item = this.track.querySelector('.recently-viewed__item');
          if (!item) return;
          const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
          const step = item.getBoundingClientRect().width + gap;
          const max = this.track.scrollWidth - this.track.clientWidth;
          const left = Math.min(Math.max(this.track.scrollLeft + step * Number(arrow.dataset.direction), 0), max);
          this.track.scrollTo({ left, behavior: 'smooth' });
        });
      });
      this.track.addEventListener('scroll', () => this.updateArrows(), { passive: true });
      this.resizeObserver = new ResizeObserver(() => this.updateArrows());
      this.resizeObserver.observe(this);

      if (ids.length > 0) this.load(ids);
    }

    disconnectedCallback() {
      this.resizeObserver?.disconnect();
    }

    /* 保存できないブラウザー（プライベートモードなど）では欄を出さないだけにする */
    readHistory() {
      try {
        const history = JSON.parse(localStorage.getItem(RecentlyViewed.storageKey) || '[]');
        return Array.isArray(history) ? history.map(String) : [];
      } catch (error) {
        return [];
      }
    }

    saveHistory(history) {
      try {
        localStorage.setItem(RecentlyViewed.storageKey, JSON.stringify(history.slice(0, 13)));
      } catch (error) {
        /* 保存できなくても表示には影響しない */
      }
    }

    async load(ids) {
      const params = new URLSearchParams({
        q: ids.map((id) => `id:${id}`).join(' OR '),
        type: 'product',
        'options[unavailable_products]': 'last',
        section_id: 'recently-viewed-items',
      });
      try {
        const response = await fetch(`${this.dataset.searchUrl}?${params}`);
        if (!response.ok) throw new Error(response.status);
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const sources = new Map(
          Array.from(html.querySelectorAll('[data-recent-item]')).map((source) => [source.dataset.productId, source]),
        );
        const items = ids
          .filter((id) => sources.has(id))
          .map((id) => {
            const item = document.createElement('li');
            item.className = 'recently-viewed__item';
            item.append(...sources.get(id).childNodes);
            return item;
          });
        if (items.length === 0) return;
        this.track.replaceChildren(...items);
        this.hidden = false;
        this.updateArrows();
      } catch (error) {
        /* 読み込めないときは欄を出さない */
      }
    }

    updateArrows() {
      const max = this.track.scrollWidth - this.track.clientWidth;
      this.arrowGroup.hidden = max <= 1;
      const [previous, next] = this.arrows;
      previous.disabled = this.track.scrollLeft <= 1;
      next.disabled = this.track.scrollLeft >= max - 1;
    }
  }

  if (!customElements.get('recently-viewed')) customElements.define('recently-viewed', RecentlyViewed);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search"]) return;
  try {
    
  class SearchField extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('input[name="q"]');
      this.clear = this.querySelector('[data-search-clear]');
      this.input.addEventListener('input', () => (this.clear.hidden = this.input.value === ''));
      this.clear.addEventListener('click', () => {
        this.input.value = '';
        this.clear.hidden = true;
        this.input.focus();
      });
    }
  }

  /* 表示していないタブの件数を読み込む。記事が0件なら「記事」タブを出さない */
  const searchTabCounts = new Map();

  class SearchTabs extends HTMLElement {
    async connectedCallback() {
      const url = this.dataset.countUrl;
      try {
        if (!searchTabCounts.has(url)) {
          searchTabCounts.set(
            url,
            fetch(url)
              .then((response) => (response.ok ? response.text() : Promise.reject(response.status)))
              .then((html) =>
                Number(
                  new DOMParser().parseFromString(html, 'text/html').querySelector('[data-search-count]')?.dataset
                    .searchCount || 0,
                ),
              ),
          );
        }
        const count = await searchTabCounts.get(url);
        const empty = Array.from(this.querySelectorAll('[data-tab-count]')).find(
          (element) => element.textContent.trim() === '',
        );
        if (empty) empty.textContent = this.dataset.countTemplate.replace('[count]', count);
        const optional = this.querySelector('[data-tab-optional]');
        if (optional && count > 0) optional.hidden = false;
      } catch (error) {
        searchTabCounts.delete(url);
      }
    }
  }

  /* 検索結果0件のとき、検索画面と同じ人気商品（sections/predictive-search.liquid）を読み込む */
  class SearchPopular extends HTMLElement {
    async connectedCallback() {
      try {
        const response = await fetch(this.dataset.url);
        if (!response.ok) throw new Error(response.status);
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const panel = html.querySelector('.search-panel');
        if (panel) this.replaceChildren(panel);
      } catch (error) {
        this.hidden = true;
      }
    }
  }

  if (!customElements.get('search-field')) customElements.define('search-field', SearchField);
  if (!customElements.get('search-tabs')) customElements.define('search-tabs', SearchTabs);
  if (!customElements.get('search-popular')) customElements.define('search-popular', SearchPopular);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
  class SlideShow extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.slideshow__track');
      this.slides = Array.from(this.querySelectorAll('.slideshow__slide'));
      this.dots = Array.from(this.querySelectorAll('.slideshow__dot'));

      this.dots.forEach((dot, index) => {
        dot.addEventListener('click', () => {
          this.setCurrent(index);
          const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.scrollToSlide(index, reduced ? 'auto' : 'smooth');
        });
      });

      this.track.addEventListener(
        'scroll',
        () => {
          const width = this.track.clientWidth;
          if (width) this.setCurrent(Math.round(this.track.scrollLeft / width));
        },
        { passive: true },
      );

      // テーマエディターでスライドを選んだら、そのスライドを表示する
      this.addEventListener('shopify:block:select', (event) => {
        const index = this.slides.indexOf(event.target);
        if (index >= 0) this.scrollToSlide(index, 'auto');
      });
    }

    scrollToSlide(index, behavior) {
      this.track.scrollTo({ left: this.slides[index].offsetLeft - this.track.offsetLeft, behavior });
    }

    setCurrent(index) {
      this.dots.forEach((dot, i) => {
        if (i === index) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
    }
  }

  if (!customElements.get('slide-show')) customElements.define('slide-show', SlideShow);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["text-with-icons"] && !Shopify.designMode) return;
  try {
    
  class TextWithIcons extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.features__track');
      this.items = Array.from(this.querySelectorAll('.features__item'));
      this.dots = Array.from(this.querySelectorAll('.features__dot'));
      if (!this.dots.length) return;

      this.dots.forEach((dot, index) => {
        dot.addEventListener('click', () => {
          this.setCurrent(index);
          this.track.scrollTo({ left: this.items[index].offsetLeft - this.track.offsetLeft, behavior: 'smooth' });
        });
      });

      this.track.addEventListener(
        'scroll',
        () => {
          const width = this.track.clientWidth;
          if (width) this.setCurrent(Math.round(this.track.scrollLeft / width));
        },
        { passive: true },
      );
    }

    setCurrent(index) {
      this.dots.forEach((dot, i) => {
        if (i === index) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
    }
  }

  if (!customElements.get('text-with-icons')) customElements.define('text-with-icons', TextWithIcons);

  } catch(e) { console.error(e); }
})();
})();
